import React, { useState, useEffect } from 'react';
import ResultText from './ResultText';

import './styles.css'

import * as firebase from 'firebase';
import settings from '../../settings'

import like from '../../assets/heart-blue.png';
import send from '../../assets/send.png';
import CardComment from './CardComment';
import Spinner from 'react-spinner-material';
import PubSub from 'pubsub-js'
import uuidv4 from 'uuid/v4'
import Snackbar from '@material-ui/core/Snackbar';

var perfil1 = 0
var perfil2 = 0
var perfil3 = 0
var perfil4 = 0
var perfil5 = 0
var perfil6 = 0
var perfil7 = 0
var perfil8 = 0
var perfil9 = 0
var max = 0
var resultadoPerfilNome = ''
var resultadoPerfilNumero = 0

export default function Result({ history }) {

    const [answers, setAnswers] = useState(JSON.parse(localStorage.getItem("questions")));
    const [resultNumber, setResultNumber] = useState(0);
    const [resultPoints, setResultPoints] = useState(0);
    const [qtLikes, setQtLikes] = useState(localStorage.getItem("qtLikes"));
    const [commentText, setCommentText] = useState('')
    const [finishReadComments, setFinishReadComments] = useState(false)
    const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [updateComments, setUpdateComments] = useState(false)
    const [editComment, setEditComment] = useState(false)
    const [commentToEdit, setCommentToEdit] = useState(false)
    const [getUserData, setGetUserData] = useState(false)
    const [facebookLogin, setFacebookLogin] = useState(localStorage.getItem("facebookLogin") || false)
    const [comments, setComments] = useState([])
    const [userLogged, setUserLogged] = useState(JSON.parse(localStorage.getItem("userLogged")))
    const [userReaded, setUserReaded] = useState('false')
    var arrComments = []

    useEffect(() => {
        if (!getUserData) {
            getResult()
            setGetUserData(true)
        }

        if (facebookLogin) {
            if (!finishReadComments) {
                const userId = localStorage.getItem("userId")
                if (userId != null && userId != '' && userId != undefined) {
                    if (!userReaded) {
                        getUser(userId)
                    }
                    getComments()
                } else {
                    setFacebookLogin(false)
                    setFinishReadComments(false)
                }
            } else if (finishReadComments && updateComments) {
                setUpdateComments(false)
                getComments()
            }
        }

        if (editComment) {
            setCommentText(commentToEdit.comment)
        }
    }, [userReaded, finishReadComments, updateComments, commentToEdit])

    function getUser(id) {
        firebase.database().ref('/usuarios/' + id).once('value').
            then(function (snapshot) {
                if (snapshot != null && snapshot.val() != null) {

                    var numberResult = 0
                    var number = 0
                    var qtComments = 0
                    var qtLikes = 0
                    var deviceId = ''
                    var whoLiked = []
                    var feito = false
                    var perfil1 = 0
                    var perfil2 = 0
                    var perfil3 = 0
                    var perfil4 = 0
                    var perfil5 = 0
                    var perfil6 = 0
                    var perfil7 = 0
                    var perfil8 = 0
                    var perfil9 = 0

                    firebase.database().ref('/usuarios/' + localStorage.getItem('userId')).once('value').then(function (snapshot) {
                        console.log("Getting user data!")
                        console.log(snapshot.val())
                        qtComments = (snapshot.val() && snapshot.val().qtComments) || 0;
                        qtLikes = (snapshot.val() && snapshot.val().qtLikes) || 0;
                        deviceId = (snapshot.val() && snapshot.val().deviceId) || 0;
                        whoLiked = (snapshot.val() && snapshot.val().whoLiked) || [];
                        number = (snapshot.val() && snapshot.val().resultado.resultadoPerfilNumero) || 0;
                        numberResult = (snapshot.val() && snapshot.val().resultado.max) || 0;
                        feito = (snapshot.val() && snapshot.val().resultado.feito) || false;
                        perfil1 = (snapshot.val() && snapshot.val().resultado.perfil1) || 0;
                        perfil2 = (snapshot.val() && snapshot.val().resultado.perfil2) || 0;
                        perfil3 = (snapshot.val() && snapshot.val().resultado.perfil3) || 0;
                        perfil4 = (snapshot.val() && snapshot.val().resultado.perfil4) || 0;
                        perfil5 = (snapshot.val() && snapshot.val().resultado.perfil5) || 0;
                        perfil6 = (snapshot.val() && snapshot.val().resultado.perfil6) || 0;
                        perfil7 = (snapshot.val() && snapshot.val().resultado.perfil7) || 0;
                        perfil8 = (snapshot.val() && snapshot.val().resultado.perfil8) || 0;
                        perfil9 = (snapshot.val() && snapshot.val().resultado.perfil9) || 0;

                        const userLoggedLocal = {
                            deviceId: deviceId,
                            email: localStorage.getItem("email"),
                            id: localStorage.getItem("userId"),
                            imagemPerfil: localStorage.getItem("userPicture"),
                            nome: localStorage.getItem("name"),
                            qtComments: qtComments,
                            qtLikes: qtLikes,
                            whoLiked: whoLiked,
                            resultado: {
                                feito: feito,
                                max: numberResult,
                                perfil1: perfil1,
                                perfil2: perfil2,
                                perfil3: perfil3,
                                perfil4: perfil4,
                                perfil5: perfil5,
                                perfil6: perfil6,
                                perfil7: perfil7,
                                perfil8: perfil8,
                                perfil9: perfil9,
                                resultadoPerfilNome: ResultText.type_names[number - 1],
                                resultadoPerfilNumero: number
                            }
                        }
                        setUserLogged(userLoggedLocal)
                        setUserReaded(true)
                        console.log("userLoggedLocal")
                        console.log(userLoggedLocal)
                    })

                }
            })
    }

    async function writeResultUser() {
        var userId = localStorage.getItem("userId") || ''
        if (userId != '' && userId != undefined && userId != null) {
            console.log("Saving user data!")
            const userLoggedLocal = {
                deviceId: localStorage.getItem("deviceId"),
                email: localStorage.getItem("email") || '',
                id: userId,
                imagemPerfil: localStorage.getItem("userPicture") || '',
                nome: localStorage.getItem("name") || '',
                qtComments: 2,
                qtLikes: 1,
                whoLiked: ["2379636155654183"],
                resultado: {
                    feito: true,
                    max: max,
                    perfil1: perfil1,
                    perfil2: perfil2,
                    perfil3: perfil3,
                    perfil4: perfil4,
                    perfil5: perfil5,
                    perfil6: perfil6,
                    perfil7: perfil7,
                    perfil8: perfil8,
                    perfil9: perfil9,
                    resultadoPerfilNome: resultadoPerfilNome,
                    resultadoPerfilNumero: resultadoPerfilNumero
                }
            }
            console.log(userLoggedLocal)
            localStorage.setItem('userLogged', JSON.stringify(userLoggedLocal));
            firebase.database().ref('usuarios/' + userLoggedLocal.id).set(userLoggedLocal);
        }
        else {
            console.log("User not logged!")
        }
    }

    function handleGoToDetails() {
        history.push('/details')
    }

    function getPerfil1() {
        return answers[8] + answers[13] + answers[21] + answers[24] + answers[47] + answers[48] +
            answers[52] + answers[56] + answers[66] + answers[89] + answers[108] + answers[118] +
            answers[123] + answers[124] + answers[125];

    }

    function getPerfil2() {
        return answers[9] + answers[49] + answers[63] + answers[68] + answers[70] + answers[90] +
            answers[91] + answers[96] + answers[98] + answers[101] + answers[106] + answers[112] +
            answers[115] + answers[129] + answers[134];

    }

    function getPerfil3() {
        return answers[1] + answers[2] + answers[10] + answers[23] + answers[26] + answers[40] +
            answers[44] + answers[65] + answers[73] + answers[83] + answers[104] + answers[106] +
            answers[110] + answers[120] + answers[131];
    }

    function getPerfil4() {
        return answers[14] + answers[18] + answers[25] + answers[30] + answers[32] + answers[33] +
            answers[38] + answers[39] + answers[50] + answers[57] + answers[58] + answers[74] +
            answers[78] + answers[86] + answers[107];
    }

    function getPerfil5() {
        return answers[4] + answers[17] + answers[29] + answers[35] + answers[36] + answers[42] +
            answers[71] + answers[72] + answers[81] + answers[84] + answers[94] + answers[101] +
            answers[128] + answers[132] + answers[133];
    }

    function getPerfil6() {
        return answers[0] + answers[3] + answers[5] + answers[6] + answers[11] + answers[15] +
            answers[22] + answers[27] + answers[60] + answers[64] + answers[75] + answers[77] +
            answers[88] + answers[114] + answers[116];
    }

    function getPerfil7() {
        return answers[7] + answers[12] + answers[16] + answers[37] + answers[76] + answers[79] +
            answers[80] + answers[87] + answers[92] + answers[93] + answers[99] + answers[109] +
            answers[113] + answers[121] + answers[126];
    }

    function getPerfil8() {
        return answers[20] + answers[31] + answers[34] + answers[43] + answers[46] + answers[51] +
            answers[53] + answers[59] + answers[61] + answers[85] + answers[97] + answers[102] +
            answers[103] + answers[122] + answers[130];
    }

    function getPerfil9() {
        return (answers[19] + answers[28] + answers[41] + answers[45] + answers[54] + answers[55] +
            answers[62] + answers[69] + answers[82] + answers[95] + answers[111] + answers[117] +
            answers[119] + answers[127] + answers[67]);
    }

    function getResult() {
        //Check if questions has answered now
        if(localStorage.getItem("number") && localStorage.getItem("number") != ""){
            setResultNumber(localStorage.getItem("number"))
            setResultPoints(localStorage.getItem("numberResult"))
        }
        else{
            var numberResult = getPerfil1();
            var number = 1;

            perfil1 = getPerfil1();
            perfil2 = getPerfil2();
            perfil3 = getPerfil3();
            perfil4 = getPerfil4();
            perfil5 = getPerfil5();
            perfil6 = getPerfil6();
            perfil7 = getPerfil7();
            perfil8 = getPerfil8();
            perfil9 = getPerfil9();
            localStorage.setItem('perfil1', perfil1);
            localStorage.setItem('perfil2', perfil2);
            localStorage.setItem('perfil3', perfil3);
            localStorage.setItem('perfil4', perfil4);
            localStorage.setItem('perfil5', perfil5);
            localStorage.setItem('perfil6', perfil6);
            localStorage.setItem('perfil7', perfil7);
            localStorage.setItem('perfil8', perfil8);
            localStorage.setItem('perfil9', perfil9);

            console.log(`Perfil 1: ${getPerfil1()}`)
            console.log(`Perfil 2: ${getPerfil2()}`)
            console.log(`Perfil 3: ${getPerfil3()}`)
            console.log(`Perfil 4: ${getPerfil4()}`)
            console.log(`Perfil 5: ${getPerfil5()}`)
            console.log(`Perfil 6: ${getPerfil6()}`)
            console.log(`Perfil 7: ${getPerfil7()}`)
            console.log(`Perfil 8: ${getPerfil8()}`)
            console.log(`Perfil 9: ${getPerfil9()}`)

            if (getPerfil2() > numberResult) {
                numberResult = getPerfil2();
                number = 2;
            }

            if (getPerfil3() > numberResult) {
                numberResult = getPerfil3();
                number = 3;
            }

            if (getPerfil4() > numberResult) {
                numberResult = getPerfil4();
                number = 4;
            }

            if (getPerfil5() > numberResult) {
                numberResult = getPerfil5();
                number = 5;
            }

            if (getPerfil6() > numberResult) {
                numberResult = getPerfil6();
                number = 6;
            }

            if (getPerfil7() > numberResult) {
                numberResult = getPerfil7();
                number = 7;
            }

            if (getPerfil8() > numberResult) {
                numberResult = getPerfil8();
                number = 8;
            }

            if (getPerfil9() > numberResult) {
                numberResult = getPerfil9();
                number = 9;
            }

            setResultNumber(number)
            setResultPoints(numberResult)

            max = numberResult
            resultadoPerfilNome = ResultText.type_names[number - 1]
            resultadoPerfilNumero = number

            localStorage.setItem("numberResult", numberResult);
            localStorage.setItem("number", number);
            localStorage.setItem("typeAndName", ResultText.type_and_name[number - 1]);
            localStorage.setItem("testDone", true);

            writeResultUser()
        }
    }

    function getComments() {
        firebase.database().ref('/User-Likes-And-Comments/Comments/' + localStorage.getItem("userId")).once('value').
            then(function (snapshot) {
                if (snapshot != null && snapshot.val() != null) {
                    snapshot.forEach(function (childData) {
                        arrComments.push(childData.val())
                    });
                    arrComments = arrComments.sort((a, b) => parseFloat(a.timestamp) - parseFloat(b.timestamp))
                    setComments(arrComments)
                    setFinishReadComments(true)
                }
            })
    }

    var mySubscriberUpdateComments = function (msg, data) {
        if (finishReadComments) {
            console.log(msg, data);
            setFinishReadComments(false)
        }
    };

    var mySubscriberEditComment = function (msg, data) {
        if (!editComment) {
            console.log(data);
            setCommentToEdit(findCommentById(data))
            setEditComment(true)
        }
    };

    var mySubscriberReportComment = async function (msg, data) {
        if (!editComment) {
            console.log(data);
            const commentToReport = findCommentById(data)
            console.log('commentToReport')
            console.log(commentToReport)
            firebase.database().ref(`/User-Likes-And-Comments/Comments-Reported/${commentToReport.idComment}`).set(commentToReport)
            setToastMessage('Comentário reportado!')
            setOpenToast(true)
        }
    };

    var mySubscriberDeletedComment = async function (msg, data) {
        setToastMessage('Comentário deletado!')
        setOpenToast(true)
    };

    function findCommentById(idComment) {
        var findedComment = ''
        comments.map(comment => {
            if (comment.idComment.localeCompare(idComment) == 0) {
                findedComment = comment
            }
        })

        return findedComment
    }

    function sendComment(e) {
        if (commentText.length > 2) {
            e.preventDefault()
            const uuid = uuidv4();
            if (editComment) {
                console.log("Send text to update")
                firebase.database().ref(`/User-Likes-And-Comments/Comments/${localStorage.getItem("userId")}/${commentToEdit.idComment}`).set(
                    {
                        comment: commentText,
                        idComment: commentToEdit.idComment,
                        idUser: commentToEdit.idUser,
                        imgUrl: commentToEdit.imgUrl,
                        name: commentToEdit.name,
                        timestamp: commentToEdit.timestamp,
                        userIdWithComment: commentToEdit.userIdWithComment
                    }
                )
                setToastMessage('Comentário editado!')
                setOpenToast(true)
                setEditComment(false)
            } else {
                firebase.database().ref('/User-Likes-And-Comments/Comments/' + localStorage.getItem("userId") + '/' + uuid).set({
                    comment: commentText,
                    idComment: uuid,
                    idUser: localStorage.getItem("userId"),
                    imgUrl: localStorage.getItem("userPicture"),
                    name: localStorage.getItem("name"),
                    timestamp: Date.now().toString(),
                    userIdWithComment: localStorage.getItem("userId")
                })
                userLogged.qtComments++;
                firebase.database().ref('usuarios/' + localStorage.getItem("userId")).set(userLogged)
                setToastMessage('Comentário enviado!')
                //To friends who commented in this result
                getFriendsAndSendNotification()
                setOpenToast(true)
            }
            setCommentText('')
            setFinishReadComments(false)
        } else {
            setToastMessage('Comentário muito curto!')
            setOpenToast(true)
        }
    }

    function handleChange(e) {
        setCommentText(e.target.value);
    }

    function checkIfDeviceExists(resgistrationId, registrationIds, myDevice) {
        var index = 0
        for (index = 0; index < registrationIds.length; index++) {
            if (resgistrationId == registrationIds[index] || resgistrationId == myDevice) {
                console.log("Registration id canot be added")
                return true;
            }
        }
        return false
    }

    async function getUsersFriend(idUser) {
        var deviceId = ''
        await firebase.database().ref('/usuarios/' + idUser).once('value').then(function (snapshot) {
            console.log("Getting users friend data!")
            deviceId = (snapshot.val() && snapshot.val().deviceId) || '';
        })
        return deviceId
    }

    async function getFriendsAndSendNotification() {
        console.log("getFriendsAndSendNotification")
        const registrationIds = []
        var indexComment = 0
        for (indexComment = 0; indexComment < comments.length; indexComment++) {
            const resgistrationId = await getUsersFriend(comments[indexComment].idUser)
            if (resgistrationId != null && resgistrationId != undefined && resgistrationId != '') {
                if (checkIfDeviceExists(resgistrationId, registrationIds, localStorage.getItem('deviceId'))) {
                    registrationIds.push(resgistrationId)
                }
            }
        }

        if (registrationIds.length > 0) {
            //To friend who owner's the result
            const name = localStorage.getItem("name")
            sendNotification(
                `Novo comentário de ${name}`,
                `Acesse o resultado de ${name} para checar os comentários :D`,
                registrationIds,
                true
            )
        }
    }



    PubSub.subscribe('Update-Comments', mySubscriberUpdateComments);
    PubSub.subscribe('Edit-Comment', mySubscriberEditComment);
    PubSub.subscribe('Report-Comment', mySubscriberReportComment);
    PubSub.subscribe('Deleted-Comment', mySubscriberDeletedComment);

    function handlShowToast() {
        setOpenToast(false)
    }

    function sendNotification(title, message, registrationId, manyPersons) {

        var url = ""
        var data = {}
        if (manyPersons) {
            if (registrationId.length > 1) {
                url = "https://teste-eneagrama-api.herokuapp.com/send-notification-all-devices";
                data = {
                    'message_title': title,
                    'message_body': message,
                    'registration_ids': registrationId.toString()
                };
            } else {
                url = "https://teste-eneagrama-api.herokuapp.com/send-notification-device";
                data = {
                    'message_title': title,
                    'message_body': message,
                    'registration_id': registrationId[0].toString()
                };
            }
        } else {
            url = "https://teste-eneagrama-api.herokuapp.com/send-notification-device";
            data = {
                'message_title': title,
                'message_body': message,
                'registration_id': registrationId
            };
        }

        const other_params = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            method: "POST",
        };

        fetch(url, other_params)
        console.log("Enviando comentário para " + registrationId.toString())
        console.log(url)
        console.log(data)
    }

    function goToHome() {
        history.push('/home')
    }

    const items = comments.map((item) => {
        return (<li key={item.idComment} className='space-between-cards'>
            <CardComment
                imgUrl={item.imgUrl}
                name={item.name}
                idUser={item.idUser}
                idComment={item.idComment}
                timestamp={item.timestamp}
                userIdWithComment={item.userIdWithComment}
                friendUser={userLogged}
                comment={item.comment}>
            </CardComment>
        </li>)
    });


    return (
        <div>
            <div onClick={goToHome} className='container-arrow'>
                <i className="left"></i>
                <p className='text-back'>Voltar</p>
            </div>
            <p className="result"> RESULTADO </p>
            <p className="result-points">{`${resultPoints} pontos`}</p>
            <p className="result-name"> {ResultText.type_and_name[resultNumber - 1]} </p>
            <p className="result-description"> {ResultText.resume[resultNumber - 1]} </p>
            <button type="submit" className="btn-details" onClick={handleGoToDetails} value={6}>Detalhes do Resultado</button>

            <div className='friend-name-container text-card comments-like'>
                <p className='text-subtitle-comment'>Comentários</p>
                <div className='friend-name-container text-card'>
                    <span className='photo-container'>
                        <img className='icon-heart' src={like} alt="like" />
                    </span>
                    <div>
                        <p className='text-icon-like'>{qtLikes}</p>
                    </div>
                </div>
            </div>
            <form>
                <div className='friend-name-container text-card'>
                    <input type="text" onChange={handleChange} value={commentText} className='comment-input' placeholder="Fazer comentário" />
                    <span className='photo-container'>
                        <img width='35' height='35' className='icon-send' src={send} alt="send" onClick={sendComment} />
                    </span>
                </div>
            </form>
            <span className='spinner-friends' id='load'>
                <Spinner size={60} spinnerColor={"#449AE2"} visible={!finishReadComments} />
            </span>
            <div>
                <ul>{items}</ul>
            </div>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                key={'bottom,center'}
                open={openToast}
                autoHideDuration={2000}
                onClose={handlShowToast}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{toastMessage}</span>}
            />
        </div>
    );
}